import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect based on user role
    if (user) {
      console.log('Dashboard: User role is:', user.role);
      console.log('Dashboard: User object:', user);
      
      if (user.role === 'admin') {
        console.log('Dashboard: Redirecting to admin-dashboard');
        navigate('/admin-dashboard');
      } else {
        console.log('Dashboard: Redirecting to student-dashboard');
        navigate('/student-dashboard');
      }
    } else {
      console.log('Dashboard: No user data available');
    }
  }, [user, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="loading-spinner mx-auto"></div>
        <p className="mt-4 text-gray-600">대시보드를 불러오는 중...</p>
      </div>
    </div>
  );
};

export default Dashboard; 